export default function SettingsPage() {
  return (
    <div className="bg-white border rounded-xl p-6">
      <h1 className="text-xl font-bold text-gray-800">Settings</h1>
      <p className="text-gray-600 mt-2">
        Configure your preferences and application settings here.
      </p>
    </div>
  );
}
